/**
 * Image sources:
 * - Local files in /public/ — uploaded by The Unexplored Routes (actual trip photos)
 * - Pexels CDN — verified HTTP 200 for destinations without local photos
 */

const P = 'https://images.pexels.com/photos';
const Q = '?auto=compress&cs=tinysrgb';

// ── LOCAL images (actual photos from theunexploredroutes.com) ──────────────
// These are stored in /public/ and served at the root path
const LOCAL = {
  ladakh:    '/ladakh.jpg',       // Turquoise Sangam river, barren mountains — Ladakh
  kashmir:   '/kashmir.jpg',      // Green meadow, pine trees, snow peaks — Kashmir
  meghalaya: '/meghalaya.jpg',    // Crystal clear Dawki river with boat — Meghalaya
  kerala:    '/kerala.jpg',       // Houseboat on backwaters, palm trees — Kerala
  srilanka:  '/srilanka.jpg',     // Sigiriya rock fortress aerial — Sri Lanka
};

// ── PEXELS fallback for destinations without local photos ─────────────────
// 4534200 = High-altitude monastery mountains — SPITI
// 2526935 = Buddhist monastery misty hills — ARUNACHAL
// 5174013 = Green coffee plantation hills — COORG
const PEXELS = {
  spiti:     `${P}/4534200/pexels-photo-4534200.jpeg${Q}&w=800&h=500&fit=crop`,
  arunachal: `${P}/2526935/pexels-photo-2526935.jpeg${Q}&w=800&h=500&fit=crop`,
  coorg:     `${P}/5174013/pexels-photo-5174013.jpeg${Q}&w=800&h=500&fit=crop`,
};

export const DEST_IMAGES = {
  ladakh:    LOCAL.ladakh,
  kashmir:   LOCAL.kashmir,
  meghalaya: LOCAL.meghalaya,
  kerala:    LOCAL.kerala,
  spiti:     PEXELS.spiti,
  srilanka:  LOCAL.srilanka,
  arunachal: PEXELS.arunachal,
  coorg:     PEXELS.coorg,
};

// Hero slideshow — 4 local photos in correct order
export const HERO_IMGS = [
  LOCAL.ladakh,
  LOCAL.kashmir,
  LOCAL.meghalaya,
  LOCAL.kerala,
];

// Why Us section gallery — 3 unique images
export const WHY_IMGS = [
  { src: LOCAL.ladakh,    alt: 'Sangam point Ladakh turquoise river', label: 'Ladakh Adventures' },
  { src: LOCAL.kerala,    alt: 'Kerala backwaters houseboat',         label: 'Kerala Backwaters' },
  { src: PEXELS.spiti,    alt: 'Spiti Valley monastery mountains',    label: 'Himalayan Serenity' },
];

// About gallery strip — 5 local destination photos
export const GALLERY_IMGS = [
  { src: LOCAL.ladakh,    label: 'Ladakh' },
  { src: LOCAL.kashmir,   label: 'Kashmir' },
  { src: LOCAL.meghalaya, label: 'Meghalaya' },
  { src: LOCAL.kerala,    label: 'Kerala' },
  { src: LOCAL.srilanka,  label: 'Sri Lanka' },
];

// About story section
export const STORY_MAIN  = LOCAL.kashmir;
export const STORY_SMALL = LOCAL.kerala;

// Why cards (About page)
export const WHY_CARDS_IMGS = [
  LOCAL.ladakh,
  LOCAL.kashmir,
  PEXELS.spiti,
];
